var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MoreShapes } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { SharedColors } from "apparatus/library/common";
import { Group } from "paper";
import { staticImplements } from "types";
const COLORS = {
    "Zinc": "#BAC4C8",
    "Silver": SharedColors.lightMetal,
    "Aluminium": SharedColors.aluminum,
    "Gold": SharedColors.gold,
    "Copper": SharedColors.copper,
    "Impure copper": SharedColors.copper.color().darken(0.2).string(),
    "Iron": SharedColors.darkMetal,
};
let Electrode = class Electrode {
    render(appearance) {
        const { diameter, length, color } = appearance;
        const { body, top, outline } = MoreShapes.cylinder3d({ diameter, height: length });
        const strokeColor = color.color().darken(0.15).string();
        top.withFill(color.color().lighten(0.2).string());
        body.withGradientFill("right", Gradients.simple(color.color(), 15));
        outline.withStroke("default", strokeColor);
        const graphic = new Group([body, top, outline]);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            snapping: [
                { type: "wireport", at: top.bounds.center }
            ]
        };
    }
};
Electrode.properties = {
    label: "Electrode",
    defaultAppearance: {
        diameter: 20,
        length: 140,
        color: COLORS["Silver"],
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "length", label: "Length",
            min: 50, max: 250, unit: "mm"
        },
        {
            spec: "slider", key: "diameter", label: "Diameter",
            min: 10, max: 50, unit: "mm"
        },
        {
            spec: "color", key: "color", label: "Material", tier: "boost",
            demoSwatches: COLORS,
            swatches: COLORS,
        }
    ],
};
Electrode = __decorate([
    staticImplements()
], Electrode);
export { Electrode };
